import { MouseEvent } from 'react'
import { Button, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-regular-svg-icons/faSparkles'
import './OptimizeButton.css'

type Props = {
  onClick: (event: MouseEvent<HTMLElement>) => void
  tooltip?: string
}

const OptimizeButton = ({ onClick, tooltip = 'Optimize Schedule' }: Props) => {
  return (
    <Tooltip title={tooltip}>
      <Button
        type="text"
        className="optimize-button"
        icon={<FontAwesomeIcon icon={faSparkles} />}
        onClick={(e) => {
          e.stopPropagation()
          onClick(e)
        }}
        style={{
          width: 32,
          height: 32,
          padding: 0,
          borderRadius: 8,
          border: '1px solid var(--optimize-btn-border)',
          backgroundColor: 'var(--optimize-btn-bg)',
          color: 'var(--optimize-btn-color)',
          fontSize: 16,
        }}
      />
    </Tooltip>
  )
}

export default OptimizeButton
